import { render, staticRenderFns } from "./APILogEdit.vue?vue&type=template&id=984429d0&scoped=true"
import script from "./APILogEdit.vue?vue&type=script&lang=js"
export * from "./APILogEdit.vue?vue&type=script&lang=js"
import style0 from "./APILogEdit.vue?vue&type=style&index=0&id=984429d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984429d0",
  null
  
)

export default component.exports